import React, { Component } from 'react';
import './Fields.css'
import Select from 'react-select';
import Api from '../services/api';
import AuthService from '../services/auth';
import Modal from 'react-modal';
import checkCircle from '../static/vectors/check-circle.svg';

class ProfilePersonal extends Component {

  constructor(props) {
    super(props);
    let optionsHeight = [];

    let maxHeight = 210
    for(let i = 160; i <= maxHeight ; i += 1) {
      optionsHeight.push({
        value: i.toString(),
        label: `${i}cm`,
      });
    }

    let optionsBodyType = [
      {value: 'slim', 'label': 'Slim'},
      {value: 'athletic', 'label': 'Athletic'},
      {value: 'curvy', 'label': 'Curvy'},
    ];

    let optionsEthnicity = [
      {value: 'african', 'label': 'African'},
      {value: 'asian', 'label': 'Asian'},
      {value: 'caucasian', 'label': 'Caucasian'},
      {value: 'middle_eastern', 'label': 'Middle Eastern'},
      {value: 'latin', 'label': 'Latin'},
    ];

    let optionsRelationship = [
      {value: 'single', 'label': 'Single'},
      {value: 'openRelationship', 'label': 'Open relationship'},
    ];

    let optionsEducation = [
      {value: 'highSchool', 'label': 'High School'},
      {value: 'bachelor', 'label': 'Bachelor'},
      {value: 'master', 'label': 'Master'},
    ];

    this.state = {
      stepNumber: 4,
      fields: {
        height: '',
        bodyType: '',
        ethnicity: '',
        occupation: '',
        education: '',
        relationship: '',
      },
      optionsHeight,
      optionsBodyType,
      optionsEthnicity,
      optionsRelationship,
      optionsEducation,
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };


  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        const {height, bodyType, ethnicity, occupation, education, relationship, id } = response.user;
        this.setState({
          fields: {
            height,
            bodyType,
            ethnicity,
            occupation,
            education,
            relationship,
          },
          id,
        });
      });
  }

  handleSubmit(e) {

    e.preventDefault();
    let { fields, id } = this.state;

    (new Api()).put(`/users/${id}`, fields, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          isModalOpen: true,
          canSubmit: false,
          modalMessage: response.message,
        });
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    if (name !== 'occupation') {
      fields[name] = e;
    } else {
      fields[name] = e.target.value;
    }

    this.setState({ fields,
    canSubmit: true,});
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { fields, isModalOpen, modalMessage, canSubmit } = this.state;
    const { titles } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {titles[0]}
        </div>
        <form>
          <div className="field-container select">
            <div className="field-title">Your Height:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="height"
                  onChange={value => this.handleFieldChange(value.value, 'height')}
                  options={this.state.optionsHeight}
                  placeholder="Your Height"
                  value={fields.height}
                  clearable={false}
                />
              </div>
            </div>
          </div>
          <div className="field-container select">
            <div className="field-title">Bodytype:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="bodyType"
                  onChange={value => this.handleFieldChange(value.value, 'bodyType')}
                  options={this.state.optionsBodyType}
                  placeholder="Your Bodytype"
                  value={fields.bodyType}
                  clearable={false}
                />
              </div>
            </div>
          </div>
          <div className="field-container select">
            <div className="field-title">Ethnicity:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="ethnicity"
                  onChange={value => this.handleFieldChange(value.value, 'ethnicity')}
                  options={this.state.optionsEthnicity}
                  placeholder="Your Ethnicity"
                  value={fields.ethnicity}
                  clearable={false}
                />
              </div>
            </div>
          </div>
        </form>
        <div className="title">
          {titles[1]}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">Occupation:</div>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="occupation"
                  name="occupation"
                  value={fields.occupation}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container select">
            <div className="field-title">Education:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="education"
                  onChange={value => this.handleFieldChange(value.value, 'education')}
                  options={this.state.optionsEducation}
                  placeholder="Your education"
                  value={fields.education}
                  clearable={false}
                />
              </div>
            </div>
          </div>
          <div className="field-container select">
            <div className="field-title">Relationship:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="relationship"
                  onChange={value => this.handleFieldChange(value.value, 'relationship')}
                  options={this.state.optionsRelationship}
                  placeholder="Your relationship"
                  value={fields.relationship}
                  clearable={false}
                />
              </div>
            </div>
          </div>
        </form>
        <button
          className="btn submit"
          onClick={(e) => {this.handleSubmit(e);}}
          disabled={!canSubmit}
        >
          Save profile
        </button>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {this.closeModal()}}
          contentLabel="Example Modal"
          style={{
            content: {
              top: '50%',
              bottom: 'auto',
              left: '50%',
              right: 'auto',
              transform: 'translate(-50%, -50%)',
            }
          }}
        >
          <div className="content text-center">
            <img src={checkCircle} alt="check" />
            <div className="message">{modalMessage}</div>
            <button onClick={() => {this.closeModal()}}> Close X</button>
          </div>
        </Modal>
      </div>
    )
  }
}

export default ProfilePersonal;


// WEBPACK FOOTER //
// ./src/components/ProfilePersonal.js